interface PasswordValidationProps {
  password: string
  confirmPassword: string
}

export function validationPassword({ password, confirmPassword }: PasswordValidationProps) {
  const passwordErrors = {
    characters: false,
    englishLetter: false,
    numberLetter: false,
  }
  if (password.length >= 8) passwordErrors.characters = true
  if (/[a-zA-Z]/.test(password)) passwordErrors.englishLetter = true
  if (/\d/.test(password)) passwordErrors.numberLetter = true

  const isSame = password === confirmPassword
  const passwordError = password.trim() !== '' && !Object.values(passwordErrors).every(Boolean)
  const confirmPasswordError = !isSame && confirmPassword !== ''

  return {
    passwordErrors,
    passwordError,
    confirmPasswordError,
    isSame,
  }
}
